<template>
<modal class="" size="medium" @close="$emit('close')">
	<template #header>
		<h3>{{ title }}</h3>
	</template>
	<template #body>
		<div class="text-left">{{ content }}</div>
	</template>
	<template slot="footer">
		<button type="button" class="btn btn-light" @click="$emit('close')">
			{{ $t("Close") }}
		</button>
		<button type="button" class="btn" :class="`${btnType} ${loadBtn}`" @click="submit">
			{{ textBtn }}
		</button>
	</template>
</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalConfirm',
	components: {
		Modal,
	},
	props: {
		title: {
			type: String,
			default: 'Title modal',
		},
		content: {
			type: String,
			default: 'Body modal',
		},
		textBtn: {
			type: String,
			default: 'Submit',
		},
		selected: {
			type: Object,
			default: null,
		},
		btnType: {
			type: String,
			default: 'btn-primary',
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		loadBtn() {
			return this.isLoading ? 'is-loading' : '';
		},
	},
	methods: {
		submit() {
			this.$emit('submit', this.selected);
		},
	},
};
</script>
